import React from 'react';
import styled from 'styled-components';
import {Play} from 'lucide-react';

const TestButtonContainer = styled.a`
  position: fixed;
  bottom: 30px;
  right: 110px;
  height: 60px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: var(--radius-sm);
  font-family: var(--font-body);
  font-size: 1.05rem;
  font-weight: 700;
  text-decoration: none;
  color: var(--color-white);
  background-color: var(--color-accent);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  box-shadow: var(--shadow-soft);
  transition: all 0.3s ease;
  z-index: 999;

  &:hover {
    background-color: var(--color-accent-hover);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;



const TestButton = () => {
  return (
    <TestButtonContainer href="https://app.sofchef.com.br" target="_blank" data-cta-id="floating-teste-gratis">
      <Play size={20} color={'#fff'}/>
      Teste grátis!
    </TestButtonContainer>
  );
};

export default TestButton;
